import { Flex } from 'antd';
import styles from './business-hours-legend.module.scss';

export function BusinessHoursLegend() {
  return (
    <Flex gap={16} className={styles.legend}>
      <Flex align="center" gap={6}>
        <div className={styles.legendDotPermanent} />
        <span>Permanent</span>
      </Flex>
      <Flex align="center" gap={6}>
        <div className={styles.legendDotTemporary} />
        <span>Temporary</span>
      </Flex>
      <Flex align="center" gap={6}>
        <div className={styles.legendDotClosed} />
        <span>Closed</span>
      </Flex>
    </Flex>
  );
}
